import axios from "axios";
import Cookies from "js-cookie";

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getsinglerace = createSlice({
    name: 'singlerace',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchsinglerace.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchsinglerace.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchsinglerace.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setRace, setStatus } = getsinglerace.actions;
export default getsinglerace.reducer;

export const fetchsinglerace = createAsyncThunk('/singleraceget/fetch', async ({ id }) => {
    const token = Cookies.get("token");
    const baseUrl = getBaseUrl().replace(/\/+$/, "");
    const headers = {};
    if (token && token !== "undefined") {
        headers.Authorization = token;
        headers["x-xsrf-token"] = token;
    }
    const res = await axios.get(`${baseUrl}/SingleRaceDetail/${id}`, {
        headers
    });
    const raceData = res.data;
    return raceData;
})